/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { scrollToAnchor } from "../../../../theme/commonStyle";
import { Theme } from "@mui/material";

const trustSectionStyle = {
  section: {
    textAlign: "center",
  },
  slide: (theme: Theme) => ({
    [theme.breakpoints.up("xs")]: {
      flexBasis: "100%",
    },
    [theme.breakpoints.up("sm")]: {
      flexBasis: "50%",
    },
    [theme.breakpoints.up("md")]: {
      flexBasis: "calc(100% / 3)",
    },
    [theme.breakpoints.up("lg")]: {
      flexBasis: "25%",
    },
    padding: "1rem 0 3rem 0",
  }),
  carouselContainer: {
    marginTop: "2rem",
  },
  heading: {
    marginBottom: "3.25rem",
  },
  logoContainer: (theme: Theme) => ({
    [theme.breakpoints.up("md")]: {
      marginTop: "40px",
    },
    backgroundColor: "#fff",
    padding: "16px 20px 10px 20px",
    borderRadius: "5px",
  }),
  sealContainer: {
    maxWidth: { xs: "80%", lg: "100%" },
    marginLeft: "auto",
    marginRight: "auto",
  },
  logo: {
    maxWidth: "100%",
  },
  peGoldLogo: {
    width: "200px",
    maxHeight: "200px",
  },
  gridItem: (theme: Theme) => ({
    [theme.breakpoints.down("md")]: {
      marginTop: "30px",
    },
  }),
  scrollToAnchor,
};

export default trustSectionStyle;
